module.exports = __webpack_public_path__ + "static/img/wbz905bb.e89fe7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wbz905bb.jpg
// module id = VsFa
// module chunks = 0